import { Card } from '../index';
import classes from 'classnames';
import React, { memo, PropsWithChildren, ReactElement, ReactNode } from 'react';
import styles from './CardGroup.module.scss';

export type CardGroupProps = {
  className?: string;
  cardWrapperClassName?: string;
  children: (ReactElement<typeof Card> | false)[];
  desktopAlign?: 'row' | 'column';
};

export default memo(function CardGroup({
  className,
  cardWrapperClassName,
  children: childrenProps,
  desktopAlign = 'column',
}: PropsWithChildren<CardGroupProps>) {
  // remove elements conditionally not rendered
  const filteredChildren: ReactNode[] = childrenProps.filter((child) =>
    Boolean(child),
  );

  const getParsedChildren = (children: ReactNode[]) =>
    // remove useless border and border-radius
    React.Children.map(children, (child, position: number) => {
      if (child === null) return;

      let classesToApply;

      // classes for the first card
      if (children.length > 0 && position === 0) {
        classesToApply = classes(styles['first-card-border']);
      }

      // classes for the middle cards
      if (position > 0 && position < children.length - 1) {
        classesToApply = classes(styles['middle-card-border']);
      }

      // classes for the last card
      if (children.length > 0 && position === children.length - 1) {
        classesToApply = classes(styles['last-card-border']);
      }

      // do not apply classes when only 1 child
      if (children.length === 1) classesToApply = undefined;

      // child wrapped applying the classes
      return (
        <div className={classes(classesToApply, cardWrapperClassName)}>
          {child}
        </div>
      );
    });

  return (
    <div className={classes(styles[desktopAlign], className)}>
      {getParsedChildren(filteredChildren)}
    </div>
  );
});
